import React from 'react';
import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import SiteNav from '@/components/SiteNav';

// Branded 404 for unknown easypeazy.site paths (was a silent redirect home).
export default function NotFound() {
  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center px-6 pt-24 pb-10" data-testid="not-found-page">
      <SiteNav />
      <div className="glass-card p-8 text-center max-w-md w-full">
        <div className="w-12 h-12 bg-indigo-500/20 rounded-xl flex items-center justify-center mx-auto mb-4">
          <Compass className="w-6 h-6 text-indigo-300" />
        </div>
        <p className="text-xs uppercase tracking-widest text-indigo-300 font-semibold">Page not found</p>
        <h1 className="text-3xl font-bold text-white mt-2 mb-3" style={{ fontFamily: 'Outfit' }}>We couldn&apos;t find that page</h1>
        <p className="text-slate-400 mb-6">The link may be old or mistyped. Head home, or see what a site costs.</p>
        <div className="flex flex-col sm:flex-row gap-2 justify-center">
          <Link to="/" className="inline-flex items-center justify-center min-h-[44px] px-5 rounded-lg bg-indigo-500 hover:bg-indigo-600 text-white font-semibold">Go to EasyPeazy home</Link>
          <Link to="/pricing" className="inline-flex items-center justify-center min-h-[44px] px-5 rounded-lg text-indigo-300 hover:text-white">See pricing</Link>
        </div>
      </div>
    </div>
  );
}
